import { CoreMenu } from "@core/types";
const role = localStorage.getItem("b2b_role");
export const menu: CoreMenu[] = [
  {
    id: "home",
    title: "الرئيسية",
    translate: "MENU.HOME",
    type: "item",
    icon: "home",
    url: "home",
    role: ["Admin", "Assistant", "Organizer"],
  },
  {
    id: "apps",
    type: "section",
    title: "الجداول الأساسية",
    translate: "MENU.APPS.SECTION",
    icon: "package",
    role: ["Admin", "Assistant", "Organizer"],
    children: [
      {
        id: "events",
        title: "الفعاليات",
        translate: "MENU.APPS.EVENTS",
        type: "item",
        icon: "calendar",
        url: "events",
        role: ["Admin", "Assistant", "Organizer"],
      },

      {
        id: "organizers",
        title: "المشرفين",
        translate: "MENU.APPS.ORGANIZERS",
        type: "item",
        icon: "crosshair",
        url: "organizers",
        role: ["Admin", "Assistant"],
      },
      {
        id: "users",
        title: "المستخدمين",
        translate: "MENU.APPS.USERS",
        type: "item",
        icon: "users",
        url: "users",
        role: ["Admin"],
      },
    ],
  },
  {
    id: "helpers",
    type: "section",
    title: "الجداول المساعدة",
    translate: "MENU.HELPERS.SECTION",
    icon: "package",
    role: ["Admin"],
    children: [
      {
        id: "org-orders",
        title: "طلبات المشرفين",
        translate: "MENU.HELPERS.ORGORDERS",
        type: "item",
        icon: "mail",
        url: "org-orders",
        role: ["Admin"],
      },
      {
        id: "event-categories",
        title: "فئات المناسبات",
        translate: "MENU.HELPERS.EVENTCATEGORIES",
        type: "item",
        icon: "list",
        url: "event-categories",
        role: ["Admin"],
      },
      // {
      //   id: 'notifications',
      //   title: 'الإشعارات',
      //   translate: 'MENU.HELPERS.NOTIFICATIONS',
      //   type: 'item',
      //   icon: 'bell',
      //   url: 'notifications'
      // },
      {
        id: "offers",
        title: "العروض",
        translate: "MENU.HELPERS.OFFERS",
        type: "item",
        icon: "speaker",
        url: "offers",
        role: ["Admin"],
      },
      {
        id: "admins",
        title: "المسئولين",
        translate: "MENU.HELPERS.ADMINS",
        type: "item",
        icon: "lock",
        url: "admins",
        role: ["Admin"],
      },
      {
        id: "reports",
        title: "التقارير",
        // translate: 'MENU.HELPERS.REPORTS',
        type: "collapsible",
        icon: "file-text",
        role: ["Admin"],
        children: [
          {
            id: "organizers-reports",
            title: "تقارير المشرفين",
            // translate: 'MENU.HELPERS.ORGANIZERS_REPORTS',
            type: "item",
            icon: "circle",
            url: "organizers-reports",
            role: ["Admin"],
          },
          {
            id: "organizers-check-in-and-out",
            title: "تسجيل دخول و خروج المشرفين ",
            // translate: 'MENU.HELPERS.ORGANIZERS_REPORTS',
            type: "item",
            icon: "circle",
            url: "organizers-check-in-and-out",
            role: ["Admin"],
          },
          {
            id: "scan-logs",
            title: "تقارير مسح التذاكر",
            // translate: 'MENU.HELPERS.ORGANIZERS_REPORTS',
            type: "item",
            icon: "circle",
            url: "scan-logs",
            role: ["Admin"],
          },
          {
            id: "user-cart-items",
            title: "تقارير تذاكر المستخدمين",
            // translate: 'MENU.HELPERS.ORGANIZERS_REPORTS',
            type: "item",
            icon: "circle",
            url: "user-cart-items",
            role: ["Admin"],
          },
        ],
      },
    ],
  },
];
